export const smallCaps = {
  letterSpacing: '0.1em',
  textTransform: 'uppercase'
};
